<template>
  <el-tooltip placement="top" :disabled="!tooltip">
    <div slot="content" class="pl-chip__tip">
      <div>{{ longName }}</div>
      <div>{{ chip.text }}</div>
      <div v-if="chip.note">{{ chip.note }}</div>
      <div v-if="chip.applyBlockedText">{{ chip.applyBlockedText }}</div>
    </div>
    <el-tag
      :type="chip.tagType"
      size="mini"
      :class="['pl-chip', clickable ? 'pl-chip--clickable' : '']"
      @click.native="onClick">
      <span class="pl-chip__partner">{{ displayName }}</span>
      <span class="pl-chip__text">{{ chip.text }}</span>
    </el-tag>
  </el-tooltip>
</template>

<script>
import { PARTNER, partnerChipOf, partnerDisplayName, partnerLinkOf, partnerLongName } from '@/utils/partnerLink'

/**
 * 외부 채널 연동 chip 하나. 문구·톤·버튼은 `utils/partnerLink.partnerLinkChip` 한 곳이 만든다(SSOT) —
 * 이 컴포넌트는 그 결과를 그리기만 한다(`DeliveryMenuChip` 과 같은 골격).
 *
 * chip 문구는 「채널명 · 상태」로 읽힌다(계획 §1.2) — 채널명은 여기서 앞에 붙이고 상태 낱말은 util 이 만든다.
 */
export default {
  name: 'PartnerLinkChip',

  props: {
    /** `PartnerLinkView` 1건 */
    view: { type: Object, default: null },
    /** 채널 코드 또는 참여 축의 가상 코드(`PARTICIPATION_CHIP_KEY`) — 축 판정은 `partnerChipOf` 한 곳이 한다 */
    partner: { type: String, default: PARTNER.MYTOWN },
    clickable: { type: Boolean, default: true },
    tooltip: { type: Boolean, default: true },
  },

  computed: {
    /** 참여 축에는 링크 행이 없다 — `select` 를 듣는 쪽은 `null` 을 그대로 받는다(없는 것을 지어내지 않는다) */
    link() {
      return partnerLinkOf(this.view, this.partner)
    },
    chip() {
      return partnerChipOf(this.view, this.partner)
    },
    displayName() {
      return partnerDisplayName(this.partner)
    },
    longName() {
      return partnerLongName(this.partner)
    },
  },

  methods: {
    onClick() {
      if (!this.clickable) return
      this.$emit('select', { view: this.view, link: this.link, chip: this.chip })
    },
  },
}
</script>

<style scoped>
.pl-chip {
  margin: 1px 3px 1px 0;
}
.pl-chip--clickable {
  cursor: pointer;
}
.pl-chip__partner {
  font-weight: 600;
}
.pl-chip__partner::after {
  content: ' · ';
}
.pl-chip__text {
  opacity: 0.9;
}
.pl-chip__tip {
  line-height: 1.6;
  max-width: 280px;
}
</style>
